import React from "react";
import PortfolioBook from "./gui/components/Book/PortfolioBook";

const App: React.FC = () => {
    return (
        <div id="app-portfolio">
            <div id="portfolio-book">
                <PortfolioBook />
            </div>
        </div>
    );
};

export default App;
